let initialIdNum = 0;

export const getUUID = () => {
    if (typeof crypto !== 'undefined') return crypto.randomUUID();
    return `id_${initialIdNum++}`;
}

export const round = (number) => Math.round(number * 100) / 100;
